<template>
  <div class="container-fluid">
    <form @submit.prevent="submit" >
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <input type="hidden" v-model="form.id"/>
        <div class="form-group" v-if="errors.length" >
          <ul class="list-group">
            <li class="list-group-item list-group-item-danger" v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div class="form-group input-group-sm">
          <label >Nazwa produktu</label>
          <search-input
            v-model="form.name"
            v-bind:items="productsNames"
          />
        </div>
        <div class="form-group input-group-sm">
          <label >Kategorie</label>
          <input type="text"
            class="form-control mb-3"
            placeholder="Szukaj"
            v-model="categoryFilter"
            @keyup="onCategoriesFilterChange">
          <select multiple class="form-control select-size" v-model="categoriesIds">
            <option v-for="option in categories" :key="option.id" v-bind:value="option.id" >
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="form-group input-group-sm">
          <label >Kolor</label>
          <input type="text"
            class="form-control mb-3"
            placeholder="Szukaj"
            v-model="colorFilter"
            @keyup="onColorFilterChange">
          <select multiple class="form-control select-size" v-model="form.colorIds">
            <option v-for="option in colors" :key="option.id" v-bind:value="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="form-group input-group-sm">
          <label >Model telefonu</label>
          <input type="text"
            class="form-control mb-3"
            placeholder="Szukaj"
            v-model="brandFilter"
            @keyup="onBrandFilterChange">
          <select multiple class="form-control select-size" v-model="brandsIds">
            <option v-for="option in brands" :key="option.id" v-bind:value="option.id">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="form-group" v-for="av in currentProducAvailabilies" :key="av.storeId" style="padding-bottom: 20px">
          <h6 class="font-weight-bold">{{ av.name }}</h6>
          <div class="row">
            <div class="col-md-8 input-group-sm">
              <label>Status</label>
              <select :class="'form-control status-select ' + assignStatusClassSelect(av)" v-model="av.status">
                <option :class="assignStatusClass(option.id)" v-for="option in statuses" :key="option.id" v-bind:value="option.id">
                  {{ option.text }}
                </option>
              </select>
            </div>
            <div class="col-md-2 input-group-sm">
              <label>Ilość</label>
              <input class="form-control" type="number" v-model="av.quantity">
            </div>
            <div class="col-md-2 input-group-sm">
              <label>Cena</label>
              <input class="form-control" v-model="av.price">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row ">
      <div class="col-xs-2 col-md-6 col-sm-6">
        <input class="btn btn-success btn-sm mr-2 torre-btn" type="submit" value="Zapisz">
        <router-link class="btn btn-secondary btn-sm mr-2" :to="{ name: 'main' }">Anuluj</router-link>
      </div>
      <div class="col-xs-2 col-md-6 col-sm-6 text-right">
        <button v-if="isAdmin" @click.prevent="deleteProductConfirm" class="btn btn-dark btn-sm">Usuń</button>
      </div>
    </div>
    </form>
  </div>
</template>

<script>
import userService from '@/service/userService'
import axios from 'axios'
import validator from 'validator'
import un from 'underscore'
import uns from "underscore.string"
import appConfig from '@/service/config'
import flashService from '@/service/flashService'
import priceUtils from "@/utils/PriceUtils"
import MainPresenter from "@/service/MainPresenter"
import alertify from 'alertifyjs';
import statusUtils from "@/utils/StatusUtils"
const numeral = require('numeral');

export default {
  name: 'ProductEdit',
  data: function () {
    return {
      mainPresenter: new MainPresenter(),
      statuses: appConfig.statuses(userService.isAdmin()),
      errors: [],
      categories: [],
      categoriesCpy: [],
      colors:[],
      colorsCpy:[],
      brands:[],
      brandsCopy:[],
      stores: [],
      currentProducAvailabilies: [],
      productsNames: [],
      isAdmin: userService.isAdmin(),
      brandFilter: "",
      colorFilter: "",
      categoryFilter: "",
      categoriesIds: [],
      brandsIds: [],
      storesData: {},
      form: {
        id: -1,
        name: '',
        currentStoreId: userService.getCurrentStore(),
        categoryId: null,
        brandIds: [],
        colorIds: [],
        availabilityList: [],
        productStatusList: [],
        priceList: []
      }
    }
  },
  methods: {
    assignStatusClassSelect: function(availability) {
      return appConfig.editableStatusesClass[availability.status];
    },
    assignStatusClass: function(id) {
      return appConfig.editableStatusesClass[id];
    },
    filterCategories: function () {
      if (uns.isBlank(this.categoryFilter)) {
        this.categories = this.categoriesCpy;
        return;
      }
      this.categories = un.filter(this.categoriesCpy, item => {
        return uns.include(item.name.toLowerCase(), this.categoryFilter.toLowerCase());
      });
    },
    onCategoriesFilterChange: un.debounce(function (e) {
      this.filterCategories();
    }, 150),
    filterColors: function () {
      if (uns.isBlank(this.colorFilter)) {
        this.colors = this.colorsCpy;
        return;
      }
      this.colors = un.filter(this.colorsCpy, item => {
        return uns.include(item.name.toLowerCase(), this.colorFilter.toLowerCase());
      });
    },
    onColorFilterChange: un.debounce(function (e) {
      this.filterColors();
    }, 150),
    filterBrands: function () {
      if (uns.isBlank(this.brandFilter)) {
        this.brands = this.brandsCopy;
        return;
      }
      this.brands = un.filter(this.brandsCopy, brand => {
        return uns.include(brand.name.toLowerCase(), this.brandFilter.toLowerCase());
      });
    },
    onBrandFilterChange: un.debounce(function (e) {
      this.filterBrands();
    }, 150),
    deleteProductConfirm(id) {
      const that = this
      alertify.confirm('', 'Chcesz usunąć produkt?', function(){
          that.deleteProduct(id)
        }, function(){},
      );
    },
    deleteProduct: function() {
      const req = axios({
        method: 'delete',
        url: appConfig.baseUrl + '/products/' + this.form.id + '/delete',
        data: {},
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        const msg = "Usunięto produkt " + this.form.name;
        alertify.set('notifier','position', 'top-center');
        alertify.success(msg).delay(3);
        this.$router.push({name: 'main'})
      }).catch(_ => {
        console.log("errore deleting ");
      })
    },
    assignCurrentProducAvailabilies: function() {
      this.form.availabilityList = un.map(this.currentProducAvailabilies, item => {
        return {
          storeId: item.storeId,
          quantity: parseInt(item.quantity)
        }
      });
      this.form.productStatusList = un.map(this.currentProducAvailabilies, item => {
        return {
          storeId: item.storeId,
          status: parseInt(item.status)
        }
      });
      this.form.priceList = un.map(this.currentProducAvailabilies, item => {
        var price = numeral(item.price.toString().replace(/,/g , ".")).value();
        return {
          storeId: item.storeId,
          price: price || 0
        }
      });
    },
    requiredExistingName () {
      if (userService.isAdmin())
        return false;
      var productName = this.form.name || ""
      productName = productName.trim()
      return !un.contains(this.productsNames, productName)
    },
    validate () {
      var err = []
      err = statusUtils.validateProducAvailabilies(this.currentProducAvailabilies)
      if (validator.isEmpty(this.form.name)) {
        err.push('Podaj nazwe produktu')
      }
      if (this.requiredExistingName()) {
        err.push('Wpisz istniejącą nazwę produktu')
      }
      if (this.form.colorIds.length > 1) {
        err.push('Wybierz tylko jeden kolor')
      }
      if (this.form.colorIds.length === 0) {
        err.push('Wybierz kolor')
      }
      if (this.categoriesIds.length > 1) {
        err.push('Wybierz tylko jedną kategorię')
      }
      if (this.categoriesIds.length === 0) {
        err.push('Wybierz kategorię')
      }
      if (this.brandsIds.length > 1) {
        err.push('Wybierz tylko jeden model')
      }
      if (this.brandsIds.length === 0) {
        err.push('Wybierz model')
      }
      un.each(this.currentProducAvailabilies, (item) => {
        if (item.price <= 0 && item.storeId == this.form.currentStoreId)
          err.push(`Podaj poprawną cenę dla ${item.name}`)
      })
      if (err.length > 0) {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
      return err
    },
    submit: function () {
      this.assignCurrentProducAvailabilies();
      var err = this.validate()
      if (err.length > 0) {
        this.errors = err
        return false
      }
      this.form.categoryId = this.categoriesIds[0]
      this.form.brandIds = [this.brandsIds[0]]
      const req = axios({
        method: 'post',
        url: appConfig.baseUrl + '/products/' + this.form.id + "/edit",
        data: this.form,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        console.log(res.data)
        // flashService.add("msg",{
        //   type: "alert-success",
        //   text: "Zapisano sklep"
        // });
        this.$router.push({name: 'main'})
      }).catch(err => {
        this.errors = un.map(err.response.data.errors, item => {
          return item.defaultMessage
        })
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      })
    },
    loadCategories: function() {
      const req = axios({
        method: 'get',
        url: this.mainPresenter.buildUrlWithDefaults("/categories"),
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.categories = res.data._embedded.categories
        this.categoriesCpy = res.data._embedded.categories
      }).catch(_ => {
        console.log('blad categories')
      })
    },
    loadColors: function() {
      const req = axios({
        method: 'get',
        url: this.mainPresenter.buildUrlWithDefaults("/colors"),
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.colors = res.data._embedded.colors
        this.colorsCpy = res.data._embedded.colors
      }).catch(_ => {
        console.log('blad colors')
      })
    },
    loadBrands: function() {
      const req = axios({
        method: 'get',
        url: this.mainPresenter.buildUrlWithDefaults("/brands"),
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.brands = res.data._embedded.brands
        this.brandsCopy = this.brands
      }).catch(_ => {
        console.log('blad brands')
      })
    },
    getQuantityForStore: function(storeId) {
      const item = this.storesData[storeId] || { quantity:0 }
      return item.quantity;
    },
    getStatusForStore: function(storeId) {
      const item = this.storesData[storeId] || { status:0 }
      return item.status;
    },
    getPriceForStore : function(storeId) {
      const item = this.storesData[storeId] || { price:0 }
      return priceUtils.formatPrice(item.price);
    },
    loadStores: function() {
      const req = axios({
        method: 'get',
        url: appConfig.baseUrl + '/stores?sort=name',
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.stores = res.data._embedded.stores
        this.selectedAvailabilityStore = this.stores[0].id
        this.createCurrentProducAvailabilies(this.stores)
      }).catch(err => {
        console.log(err)
        console.log('blad stores')
      })
    },
    createCurrentProducAvailabilies: function (stores) {
      this.currentProducAvailabilies = un.chain(stores)
        .map(item => {
          return {
            name: item.name,
            storeId: item.id,
            status: this.getStatusForStore(item.id),
            quantity: this.getQuantityForStore(item.id),
            price: this.getPriceForStore(item.id)
          }
        })
        .filter(item => {
          if (userService.isAdmin())
            return true
          return item.storeId ===  userService.getCurrentStore()
        })
        .value()
    },
    loadProduct: function() {
      const req = axios({
        method: 'get',
        url: appConfig.baseUrl + '/products/' + this.$route.params.id,
        data: this.form,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.form.name = res.data.torreProduct.name
        this.form.id = res.data.torreProduct.id
        this.categoriesIds = [res.data.torreProduct.categoryId]
        this.form.colorIds = [res.data.torreProduct.colorId]
        this.brandsIds = [res.data.torreProduct.brandId]
        this.storesData = res.data.storesData
        this.loadCategories();
        this.loadColors();
        this.loadBrands();
        this.loadStores();
      }).catch(e => {
        console.log(e);
        this.$router.push({name: 'main'})
      })
    },
    loadProductNames: function () {
      const req = axios({
        method: 'get',
        url: appConfig.baseUrl + "/product/allNames",
        headers: {
          Authorization: userService.getAuthHeader()
        }
      });
      req.then(res => {
        this.productsNames = res.data;
      }).catch(_ => {
        console.log("err");
      })
    },
  },
  created: function () {
    this.loadProductNames();
    this.loadProduct();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/product/ProductEdit.vue